import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import CustomMainHeader from '../components/CustomMainHeader';
import CustomSidebar from '../components/CustomSidebar';
import CustomMainFooter from '../components/CustomMainFooter';
import CustomPainelAparencia from '../components/CustomPainelAparencia';
import Notification from '../components/Notification';
import CustomBarraAtalhos from '../components/CustomBarraAtalhos';
import { ehCelularAgora } from '@/lib/tela';
import { nomeDaTela } from '../components/CustomSidebar';
import { registrarNaTrilha } from '@/lib/trilha';

const InternalLayout: React.FC = () => {
    const location = useLocation();

    /* TODA NAVEGAÇÃO ENTRA NA TRILHA — e por isso mora AQUI, no layout, e não só
       dentro da `CustomMolduraPagina`.

       O defeito, pego por ele em 31/08/2026: estando em **Viagens** (tela que
       ainda não usa a moldura) e indo lançar uma despesa, o Voltar não aparecia
       — a trilha só conhecia as telas já migradas, e Viagens não era uma. Com a
       migração das 52 telas em curso, isso valeria para a maioria dos percursos
       reais, e o recurso pareceria quebrado.

       O nome sai do MENU (`nomeDaTela`), que já é a lista das telas do app com
       o nome que a pessoa lê. Tela que a moldura desenha registra de novo, logo
       depois, com o título específico — "OS 123" em vez de "Ordens de Serviço".
       A segunda gravação sobrescreve a primeira, porque `registrarNaTrilha`
       atualiza o degrau quando o caminho é o mesmo. */
    useEffect(() => {
        const nome = nomeDaTela(location.pathname);
        if (nome) registrarNaTrilha({ caminho: location.pathname, titulo: nome });
    }, [location.pathname]);


    const adjustPadding = () => {
        const headerElement = document.querySelector(".adminuiux-header .navbar") as HTMLElement;
        const sidebarPadding = document.querySelector(".adminuiux-sidebar") as HTMLElement;
        const contentPadding = document.querySelector(".adminuiux-content") as HTMLElement;

        if (headerElement && sidebarPadding && contentPadding) {
            const headerHeight = headerElement.offsetHeight;
            contentPadding.style.paddingTop = `${headerHeight}px`;
            sidebarPadding.style.paddingTop = `${headerHeight}px`;
        }

        /* O padding de baixo reserva o espaço da BARRA DE ATALHOS DO CELULAR,
           que é fixa na janela e cobriria o fim da página.

           ⚠️ A CONDIÇÃO É A ALTURA, NÃO A EXISTÊNCIA (corrigido em 27/08/2026).
           A barra é `d-lg-none`: no desktop ela continua no DOM, só escondida.
           `querySelector` a encontrava, o `if` era tomado, e `offsetHeight` de
           elemento oculto vale 0 — então o padding ficava `calc(0px + 10px)` e
           sobravam 10px de fundo ABAIXO da faixa azul do rodapé, sem barra
           nenhuma para reservar. Era o espaço que o Vittorio viu. O `else` que
           zeraria nunca rodava: o elemento sempre existe. */
        const footerMobileElement = document.querySelector(".adminuiux-mobile-footer") as HTMLElement;
        const footerMobileHeight = footerMobileElement ? footerMobileElement.offsetHeight : 0;
        document.body.style.paddingBottom = footerMobileHeight > 0
            ? `calc(${footerMobileHeight}px + 10px + env(safe-area-inset-bottom) )`
            : "0px";
    };

    useEffect(() => {
        adjustPadding();
        window.addEventListener('resize', adjustPadding);

        const onScroll = () => {
            const headerElement = document.querySelector(".adminuiux-header");
            if (headerElement) {
                if (window.pageYOffset > 30) {
                    headerElement.classList.add("active");
                } else {
                    headerElement.classList.remove("active");
                }
            }
        };
        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('resize', adjustPadding);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const contentClick = () => {
        const body = document.body;

        if (ehCelularAgora()) {
            body.classList.remove("sidebar-open");
            body.classList.add("sidebar-close");
        }
    };

    return (

        <>
            {/* header */}
            <div className="adminuiux-header inner-page">
                <CustomMainHeader />
            </div>

            <div className="adminuiux-wrap">
                {/* sidebar */}
                <CustomSidebar />
                {/* page content */}
                <main className="adminuiux-content has-sidebar" onClick={contentClick}>
                    <Outlet />
                </main>
            </div>

            {/* color change pallette */}
            <div className="offcanvas offcanvas-end shadow border-0 width-280" tabIndex={-1} id="theming" data-bs-scroll="true" data-bs-backdrop="false" aria-labelledby="theminglabel">
                <CustomPainelAparencia />
            </div>

            {/* notification */}
            <div className="offcanvas offcanvas-end shadow border-0 width-300" tabIndex={-1} id="notification" data-bs-scroll="true" data-bs-backdrop="false" aria-labelledby="notificationlabel">
                <Notification />
            </div>

            {/* standard footer */}
            <CustomMainFooter />

            {/* Atalhos do celular. Depois do CustomMainFooter e fora do wrap: é fixa
                na janela, e o padding-bottom que o efeito acima calcula já
                reserva o espaço dela. */}
            <CustomBarraAtalhos />
        </>
    );
};

export default InternalLayout;
